import React from 'react';
import { DateDisplay } from '@lib/common';
import { Property } from '@lib/state';
import { makeStyles, createStyles, Paper, Grid, Typography } from '@material-ui/core';
import { parseISO } from 'date-fns';
import { GuestSurveyModel } from '@lib/state/api/generated/properties';

interface Props {
  survey: GuestSurveyModel;
  property?: Property;
}

const useStyles = makeStyles(() =>
  createStyles({
    dense: {
      lineHeight: 1,
    },
  })
);

export function ReservationInfo({ survey, property }: Readonly<Props>) {
  const styles = useStyles();

  return (
    <Paper square data-testid="guestSurveyForm">
      <Grid direction="row" container spacing={1}>
        <Grid item md={3} sm={6} xs={12}>
          <Typography className={styles.dense} variant="overline">
            <strong>Property</strong>
          </Typography>
          <Typography
            className={styles.dense}
            variant="body2"
            data-testid="surveyFormPropertyNameDisplay"
          >
            {property?.name}
          </Typography>
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <Typography className={styles.dense} variant="overline">
            <strong>Check-In</strong>
          </Typography>
          <DateDisplay
            className={styles.dense}
            variant="body2"
            date={parseISO(survey.checkInDate)}
            dateFormat="MM/dd/yyyy"
            testId="surveyFormCheckInDisplay"
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <Typography className={styles.dense} variant="overline">
            <strong>Check-Out</strong>
          </Typography>
          <DateDisplay
            className={styles.dense}
            variant="body2"
            date={parseISO(survey.checkOutDate)}
            dateFormat="MM/dd/yyyy"
            testId="surveyFormCheckOutDisplay"
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <Typography className={styles.dense} variant="overline">
            <strong>Reservation Number</strong>
          </Typography>
          <Typography
            className={styles.dense}
            variant="body2"
            data-testid="surveyFormConfCodeDisplay"
          >
            {survey.recordNumber}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}
